module.exports = __webpack_public_path__ + "img/thumbnail_PrzewalskisHorse_f_normal.af395e70.png";